/*
 * Copyright (c) 2023. Word Wide Generation Ltd
 */

import React from 'react'
import './TodoContainer.scss';

interface Props extends React.PropsWithChildren<any> {
  toggle: () => void;
  title?: string;
}

export const TodoContainer = (props: Props) => {
  const { toggle, title = 'To-do list' } = props;

  return (
    <div className={'todo-widget'}>
      <div className='todo-background' onClick={() => toggle()}></div>
      <div className='todo-container mt-3'>
        <div className='todo-header py-4 d-flex px-3'>
          <span className='flex-fill text-center text-medium'>{title}</span>
        </div>
        <div className='todo-body mt-2 px-3'>
          {props.children}
        </div>
      </div>
    </div>
  )
}
